import React, { useState } from 'react';
import { Phone, Menu, X, InstagramIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    t,
    language,
    toggleLanguage
  } = useLanguage();
  const navLinks = [{
    label: t('header.services'),
    href: '#servicios'
  }, {
    label: t('header.protocol'),
    href: '#protocolo'
  }, {
    label: t('header.about'),
    href: '#kate'
  }, {
    label: t('header.reviews'),
    href: '#resenas'
  }, {
    label: t('header.faq'),
    href: '#faq'
  }, {
    label: t('header.giftCard'),
    href: '#gift-card'
  }, {
    label: t('header.contact'),
    href: '#agenda'
  }];
  return <header className="sticky top-0 z-50 w-full bg-brand-dark backdrop-blur-md border-b border-brand-gold/10 md:border-brand-gold/15 shadow-sm md:shadow-lg" data-id="element-216">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <div className="flex justify-between items-center h-16 md:h-20" data-id="element-218">
          {/* Logo Image */}
          <a href="#" className="flex-shrink-0" data-id="element-219">
            <img src="https://cdn.magicpatterns.com/uploads/d5PCZLxog3stu5Kmdcos9m/tairu_new_1.png" alt="Tairu Aesthetics" className="h-14 w-auto object-contain mix-blend-lighten" data-id="element-220" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-221">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-gray-300 hover:text-brand-gold-light transition-colors tracking-wide" data-id="element-222">
                {link.label}
              </a>)}
          </nav>

          {/* Contact & CTA */}
          <div className="flex items-center space-x-4" data-id="element-223">
            <button onClick={toggleLanguage} className="text-xs font-bold tracking-widest text-gray-400 hover:text-brand-gold-light transition-colors flex items-center gap-1" aria-label="Toggle Language" data-id="element-224">
              <span className={language === 'es' ? 'text-brand-gold' : ''} data-id="element-225">
                ES
              </span>
              <span className="opacity-50" data-id="element-226">|</span>
              <span className={language === 'en' ? 'text-brand-gold' : ''} data-id="element-227">
                EN
              </span>
            </button>
            <a href="https://www.instagram.com/tairu.aesthetics/" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-300 hover:text-brand-gold-light transition-colors" aria-label="Instagram" data-id="element-228">
              <InstagramIcon className="w-5 h-5" data-id="element-229" />
            </a>
            <a href="tel:5513328938" className="hidden md:flex items-center text-gray-300 hover:text-brand-gold-light transition-colors font-medium text-sm" data-id="element-230">
              <Phone className="w-4 h-4 mr-2" data-id="element-231" />
              (551) 332-8938
            </a>
            <a href="https://book.heygoldie.com/tairu-aesthetics" target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex bg-brand-gold hover:bg-brand-gold-light text-white px-6 py-2.5 rounded-sm font-medium transition-colors duration-300 shadow-sm text-sm" data-id="element-232">
              {t('header.bookNow')}
            </a>

            {/* Mobile menu button */}
            <button onClick={() => setMobileOpen(!mobileOpen)} className="lg:hidden p-2 text-gray-300 hover:text-brand-gold-light transition-colors" aria-label="Abrir menú" data-id="element-233">
              {mobileOpen ? <X className="w-6 h-6" data-id="element-234" /> : <Menu className="w-6 h-6" data-id="element-235" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav Dropdown */}
      {mobileOpen && <div className="lg:hidden bg-brand-dark border-t border-brand-gold/10 shadow-lg" data-id="element-236">
          <nav className="max-w-7xl mx-auto px-4 py-4 space-y-1" data-id="element-237">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setMobileOpen(false)} className="block py-3 px-4 text-gray-300 hover:text-brand-gold-light hover:bg-white/5 rounded-sm transition-colors font-medium text-sm" data-id="element-238">
                {link.label}
              </a>)}
            <div className="pt-3 border-t border-brand-gold/10 mt-2" data-id="element-239">
              <a href="tel:5513328938" className="flex items-center py-3 px-4 text-gray-300 font-medium text-sm" data-id="element-240">
                <Phone className="w-4 h-4 mr-2" data-id="element-241" />
                (551) 332-8938
              </a>
              <a href="https://book.heygoldie.com/tairu-aesthetics" target="_blank" rel="noopener noreferrer" onClick={() => setMobileOpen(false)} className="block mt-2 text-center bg-brand-gold text-white py-3 rounded-sm font-medium" data-id="element-242">
                {t('header.bookNow')}
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}